/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReloadApprovalReportDataEntry } from '../../models/reload-approval-report-data-entry';

export interface ReloadApprovalReportData$Params {
  workCenterId: number;
      body: ReloadApprovalReportDataEntry
}

export function reloadApprovalReportData(http: HttpClient, rootUrl: string, params: ReloadApprovalReportData$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, reloadApprovalReportData.PATH, 'post');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

reloadApprovalReportData.PATH = '/api/v1/workCenter/{workCenterId}/approvals/reloadApprovalReportData';
